import React from 'react';
import { ChevronRight, Calendar, DollarSign } from 'lucide-react';
import StatusBadge from './StatusBadge';
import Card from './Card';

const OrderCard = ({ order, onClick }) => {
  const { code, created_at, status, total, items_count } = order;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CL', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    <Card hover onClick={onClick} className="touch-manipulation">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          {/* Header */}
          <div className="flex items-center gap-2 mb-2">
            <span className="font-display font-bold text-[#1B263B] text-lg">
              #{code}
            </span>
            <StatusBadge status={status} size="sm" />
          </div>

          {/* Date & Items */}
          <div className="flex items-center gap-4 text-sm text-[#7A756F] mb-3">
            <span className="flex items-center gap-1">
              <Calendar size={14} />
              {formatDate(created_at)}
            </span>
            <span>
              {items_count} {items_count === 1 ? 'producto' : 'productos'}
            </span>
          </div>
        </div>

        {/* Arrow */}
        <ChevronRight size={20} className="text-[#BCB8B1] flex-shrink-0" />
      </div>

      {/* Total */}
      <div className="pt-3 border-t border-[#EFEDEA] flex items-center justify-between">
        <span className="text-sm text-[#7A756F]">Total</span>
        <span className="flex items-center gap-1 font-display font-bold text-[#1B263B] text-lg">
          <DollarSign size={18} />
          {total.toLocaleString()}
        </span>
      </div>
    </Card>
  );
};

export default OrderCard;
